import React, { Component } from "react";
import Button from "@material-ui/core/Button";

import { DRAWER_WIDTH, MAIN_CONTENT_TOP } from "../components/Constants";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  formContent: {
    marginTop: `50px`,
    position: "absolute",
    marginLeft: "50px",
    marginRight: "50px",
  },
  redCell: {
    color: "red",
  },
});

class DownloadSoftwarePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
    };
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleDownloadSAND(e) {
    var strWindowFeatures =
      "location=yes,height=400,width=809,scrollbars=yes,status=yes, resizable=yes";
    //var URL = "https://www.securewebexchange.com/asdc.com/setup.exe";
    const root = document.getElementById("root");
    const URL = root.getAttribute("sand_setup_url");
    //window.location.href = URL;
    window.open(URL, "_blank", strWindowFeatures).focus();
  }

  handleDownloadSAND64(e) {
    var strWindowFeatures =
      "location=yes,height=400,width=809,scrollbars=yes,status=yes, resizable=yes";
    //var URL = "https://www.securewebexchange.com/asdc.com/setup_pcl_addon.exe";
    const root = document.getElementById("root");
    const URL = root.getAttribute("sand_setup64_url");
    //window.location.href = URL;
    window.open(URL, "_blank", strWindowFeatures).focus();
  }

  handleShowPdf(e) {
    var strWindowFeatures =
      "location=yes,height=400,width=809,scrollbars=yes,status=yes, resizable=yes";
    //var URL = "https://www.securewebexchange.com/asdc.com/instructions.pdf";
    const root = document.getElementById("root");
    const URL = root.getAttribute("sand_instructions_pdf");
    window.open(URL, "_blank", strWindowFeatures).focus();
  }

  handleCancel(e) {
    e.preventDefault();
    this.props.onResult();
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;

    return (
      <div className={classes.tableWrapper}>
        <div className={classes.formContent}>
          {t("downloadSand1.label")}
          {t("downloadSand2.label")}
          {t("downloadSand3.label")}
          <br />
          <br />
          <strong>{t("requirements.label")}: </strong>
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#8226;
          {t("downloadManual.label")}
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#8226;
          {t("supportSystem.label")}
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#8226;
          {t("printInstall.label")}
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#8226;
          {t("actualCheck.label")}
          <br />
          <br />
          {t("clickDownloadButton.label")} {t("steps.label")}
          <br />
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;- {t("downLoadAndInstall.label")}
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;- {t("register.label")}
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;- {t("setup.label")}
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;- {t("selectPrinter.label")}
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;- {t("configLayout.label")}
          <br />
          <br />
          <br />
          {t("tradeMark.label")}
          <br />
          <div style={{ marginLeft: 18, marginTop: 20 }}>
            <Button
              color="primary"
              onClick={(event) => this.handleDownloadSAND64(event)}
            >
              {t("downloadSandPrinting64.button")}
            </Button>
          </div>
          <div style={{ marginLeft: 18, marginTop: 20 }}>
            <Button
              color="primary"
              onClick={(event) => this.handleDownloadSAND(event)}
            >
              {t("downloadSandPrinting32.button")}
            </Button>
          </div>
          <div style={{ marginLeft: 18, marginTop: 20 }}>
            <Button
              color="primary"
              onClick={(event) => this.handleShowPdf(event)}
            >
              {t("showSandDocument.button")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(withStyles(styles)(DownloadSoftwarePage));
